import { useController, useFormContext } from "react-hook-form";
import ProductSelect, { type ProductSelectProps } from "./ProductSelect";

const ProductSelectFormInput = ({ id }: ProductSelectProps) => {
  const { field } = useController({ name: id });
  const {
    formState: { errors },
  } = useFormContext();
  const errorMsg = errors?.[id]?.message as string;
  return <ProductSelect id={id} errorMsg={errorMsg} {...field} />;
};

export default ProductSelectFormInput;
